<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import KeyValueMenu from '../KeyValueMenu/KeyValueMenu.vue';

export default {
    components: {
        DropdownMenu,
        KeyValueMenu
    },
    computed: {
        ...mapState({
            productTypes: state => state.auth.productTypes,
            productType: state => state.auth.productType,
            supplier: state => state.auth.supplier,
            user: state => state.auth.user,
        }),
        ...mapGetters({
            getSuppliersInProductType: 'auth/getSuppliersInProductType'
        })
    },
    methods: {
        ...mapActions({
            setProductType: 'auth/setProductType',
            setSupplier: 'auth/setSupplier'
        })
    }
}
</script>

<template>
    <div class="navigation-menu-filter">
        <div class="navigation-menu-filter__content">
            <dropdown-menu v-if="productTypes.length > 1"
                           :label="$t('navigation-menu.items.productType')"
                           :value="productType"
                           :items="productTypes"
                           :translation-prefix="'navigation-menu.items.products'"
                           @input="setProductType({productType: $event, overwrite: true})"/>
            <key-value-menu v-if="getSuppliersInProductType.length > 1"
                            :label="$t('navigation-menu.items.supplier')"
                            :value="supplier"
                            :items="getSuppliersInProductType"
                            :key="'navigation-filter-' + productType"
                            @input="setSupplier({supplier: $event, overwrite: true})"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/NavigationMenuFilter/NavigationMenuFilter.vue